module.exports = __webpack_public_path__ + "img/submit_next_button.de2d3f73.png";